import { IString } from '../../../model';
import { IPagination } from '../model';
import {
  ITableRowSelection,
  ITableScroll,
  TableRowSelectionAction,
} from '../model/table';
import { DEFAULT_PAGE_SIZE } from './constant';

export const getStickyClassName = (
  fixed: boolean | 'left' | 'right' | undefined,
  isHeader?: boolean
) => {
  if (!fixed) {
    return '';
  }
  if (fixed === true || fixed === 'left') {
    return isHeader ? 'sticky-header-left' : 'sticky-body-left';
  }
  return 'sticky-right';
};

export const getHeaderCheckedStatus = (
  rowSelection: ITableRowSelection<any>,
  dataLen: number
) => {
  if (!rowSelection.selectedRowKeys.length) {
    return TableRowSelectionAction.unchecked;
  }
  if (rowSelection.selectedRowKeys.length === dataLen) {
    return TableRowSelectionAction.checked;
  }
  return TableRowSelectionAction.indeterminate;
};

export const getBodyCheckedStatus = (
  rowSelection: ITableRowSelection<any>,
  rowKeyValue: string
) => {
  const selected = rowSelection.selectedRowKeys.some(
    (key) => key === rowKeyValue
  );
  return selected
    ? TableRowSelectionAction.checked
    : TableRowSelectionAction.unchecked;
};

export function getPageData<T>(
  dataSource: ReadonlyArray<T>,
  pagination: IPagination
) {
  const { current, pageSize = DEFAULT_PAGE_SIZE } = pagination;
  return dataSource.slice(current - 1 * pageSize, current * pageSize);
}

export const numberToArray = (num: number) => {
  const arrNumber = [];
  /* eslint-disable */
  for (let i = 0; i < num; i++) {
    arrNumber.push(i);
  }
  return arrNumber;
};

export const getTableScrollStyle = (
  scroll?: ITableScroll
): React.CSSProperties => {
  if (scroll === undefined) {
    return {};
  }

  const getValue = (value?: string | number | true) => {
    if (typeof value !== 'boolean' && value) {
      return typeof value === 'number' ? `${value}px` : value;
    }
    return '';
  };

  const width = getValue(scroll.x);
  const height = getValue(scroll.y);
  const minHeight = getValue(scroll.minY);
  const maxHeight = getValue(scroll.maxY);

  return {
    width,
    height,
    minHeight,
    maxHeight,
    overflow: 'auto',
  };
};

export const filterEmpty = (values: IString<string | string[]>) => {
  const oValues: IString<string | string[]> = {};
  /* eslint-disable */
  for (const i in values) {
    const value = values[i];
    if (value === '' || value === undefined || value === null) {
      continue;
    }
    if (Array.isArray(value)) {
      if (!value.length) {
        continue;
      }
    }
    oValues[i] = value;
  }
  return oValues;
};
